'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Utils


// Constants


var _formSubReducerWrapper = require('../../../../components/form/formSubReducerWrapper');

var _formSubReducerWrapper2 = _interopRequireDefault(_formSubReducerWrapper);

var _teamFormConstants = require('./teamFormConstants');

var _teamManagementConstants = require('../teamManagementConstants');

var _formConstants = require('../../../../components/form/formConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addTeamMemberSubFormReducer = function addTeamMemberSubFormReducer(state, action) {
    switch (action.type) {
        case _teamManagementConstants.TEAM_MEMBER_ADD_NEW:
        case _formConstants.FORM_SUBMISSION_FAILED:
            return _extends({}, state, { userEmail: { value: '' } });
        default:
            return state;
    }
};

exports.default = (0, _formSubReducerWrapper2.default)(addTeamMemberSubFormReducer, _teamFormConstants.ADD_TEAM_MEMBER_FORM_NAME);


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/team/form/teamInputFormReducer.js
// module id = 2095
// module chunks = 0